import { createClient } from '@supabase/supabase-js';
import { getSupabaseUrl } from './supabaseConfig';

// Create Supabase client using shared configuration
const supabaseUrl = getSupabaseUrl();
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1bG5ieWpyY3p2b3hlbXRyaWxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1NTYxMzYsImV4cCI6MjA1MjEzMjEzNn0.Rinzz2_HBzxalwRnWVJheDpLC4ghoBEBweweTiwf1eI';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Type assertion to allow access to specific tables
export type SupabaseClientType = typeof supabase;
export default supabase;